// Chief of Staff mode (design/2026-10-26-chief-of-staff-agents-panel.md T9):
// on the agent start screen, Session options and its Chief of Staff mode
// checkbox, then, in words only, where a running chat lists its helper
// agents. It never ticks the box or sends a message: a Chief of Staff chat
// spends credits, and the e2e run has none to point the panel at.

import type { Walkthrough } from './types'

export const chiefOfStaffMode: Walkthrough = {
  slug: 'chief-of-staff-mode',
  title: 'Chief of Staff mode',
  summary:
    'Opens Session options on the agent start screen and shows the Chief of Staff mode checkbox, then says where a Chief of Staff chat lists the agents it starts. Nothing is ticked or sent.',
  added: '2026-10-26',
  steps: [
    {
      page: 'agent',
      feature: 'agent/start-session-options',
      action: { tool: 'open_session_options', label: 'Open Session options' },
      say: 'This is Session options on the agent start screen: the jobs the chat works in, its persona and, for Managers, its mode.',
    },
    {
      page: 'agent',
      feature: 'agent/chief-of-staff-mode',
      control: 'Chief of Staff mode',
      say: 'Tick Chief of Staff mode before your first message and the agent may hand parts of the work to sub-agents and workflows, then wait for their results. A chat keeps the mode it started with; only Managers see the box.',
    },
    {
      page: 'agent',
      feature: 'agent/delegated-agents',
      action: { tool: 'close_session_options', label: 'Close Session options' },
      say: 'In a Chief of Staff chat, every sub-agent and workflow the agent starts is listed under Agents at the top of the right-hand panel; the Agents pill on its closed edge pulses while they work. Click one to read its whole conversation in a drawer.',
    },
  ],
}
